export const config = {
    api_key: null,
    timeout: 60000,
};
